module.exports = {
    apiKey: 'AIzaSyA_PcTjON5OPDP-56Bc5mp5w266sdFvxak',
    authDomain: 'fir-cellwine.firebaseapp.com',
    databaseURL: 'https://fir-cellwine.firebaseio.com',
    projectId: 'firebase-cellwine',
    storageBucket: 'firebase-cellwine.appspot.com',
    messagingSenderId: '1029498691031'
}